export default "__VITE_ASSET__28752147__"